import apiPath from './apiPath';
import { requestGet, requestPatch } from '../request';

const api = {
  GetFeeSetting() {
    return requestGet(apiPath.GLOBAL_SETTING_FEE.path);
  },

  UpdateFeeSetting(payload) {
    return requestPatch(apiPath.GLOBAL_SETTING_FEE.path, payload);
  }
};

export default api;
